<template>
  <div class="mail">
    <div class="mail__innerwrap">
      <div class="mail__row">
        <div class="mail__image-wrapper">
          <img class="mail__image" :src="image" />
        </div>
        <div class="mail__text">
          <h1 class="mail__title" v-html="page.title"></h1>
          <div class="mail__status" v-if="statusText && sent" v-html="statusText"></div>
          <div
            v-if="!sent"
            class="mail__form"
            :class="{'mail__form--sending': sending}"
          >
            <div class="mail__fields-wrapper">
              <input
                class="mail__input"
                type="text"
                v-model="firstName"
                placeholder="First name"
                :class="{ error: !validation.firstName && showValidation }"
              />
              <input
                class="mail__input"
                type="text"
                v-model="lastName"
                placeholder="Last name"
                :class="{ error: !validation.lastName && showValidation }"
              />
              <input
                class="mail__input"
                type="email"
                v-model="email"
                placeholder="Email address"
                :class="{ error: !validation.email && showValidation }"
              />
              <input
                class="mail__input"
                type="text"
                v-model="company"
                placeholder="Company"
              />
              <input
                class="mail__input"
                type="text"
                v-model="country"
                placeholder="Country"
              />
              <label class="mail__gdpr">
                <input type="checkbox" v-model="gdpr"/><em></em>
                <span v-html="page.gdpr"></span>
              </label>
            </div>
            <button
              type="submit"
              class="mail__button"
              :disabled="!gdpr"
              v-on:click.prevent="submit"
            >{{ page.cta }}</button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex';

export default {
  name: 'mail',
  data() {
    return {
      showValidation: false,
      sent: false,
      sending: false,
      statusText: '',
      emailRE: /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/, // eslint-disable-line
      firstName: '',
      lastName: '',
      email: '',
      company: '',
      country: '',
      gdpr: false,
    };
  },
  computed: {
    ...mapState(['pages']),
    page() {
      return this.pages.mail;
    },
    image() {
      return `static/${this.page.image}`;
    },
    validation() {
      return {
        email: this.emailRE.test(this.email),
        firstName: !!this.firstName.trim(),
        lastName: !!this.lastName.trim(),
      };
    },
    isValid() {
      const validation = this.validation;
      return Object.keys(validation).every(key => validation[key]);
    },
  },
  methods: {
    ...mapActions(['formSubmit']),
    submit() {
      if (!this.isValid) {
        this.showValidation = true;
        this.statusText = this.validationStatus;
        return;
      }

      this.showValidation = false;
      this.statusText = '';
      if (this.sending) {
        return;
      }

      const self = this;
      this.sending = true;
      this.formSubmit({
        email: this.email,
        Firstname: this.firstName,
        Lastname: this.lastName,
        Company: this.company,
        Country: this.country,
      }).then((success) => {
        self.sending = false;
        self.sent = true;
        if (success) {
          this.statusText = '<h2>Thank you for contacting us.</h2><p>We will be in touch with you soon.<p>';
        } else {
          this.statusText = '<h2>An error occured.</h2><p>Please try again later.</p>';
        }
      });
    },
  },
};
</script>

<style lang="scss">
@import '../styles/helpers';

.mail {
  @include section;
  padding-bottom: 0;
  display: flex;
  flex-direction: column;

  &__innerwrap {
    // width: 10/12 * 100%;
    background: $c_grey--light;
    flex-grow: 1;
  }

  &__row {
    display: flex;
  }

  &__image-wrapper {
    width: calc(6/12 * 100% - 10px);
    margin-left: -30px;
    margin-right: 40px;
    flex-shrink: 0;
    position: relative;
    margin: 10px 40px -110px -30px;

    &::after {
      content: '';
      display: block;
      width: 273px;
      height: 148px;
      background-position: center;
      background-size: contain;
      background-repeat: no-repeat;
      background-image: url('../assets/mail_arrows.svg');
      position: absolute;
      top: 0;
      right: -100px;
    }
  }

  &__image {
    display: block;
    width: 100%;
  }

  &__text  {
    width: calc(6/12 * 100% - 10px);
    margin-left: 30px;
    flex-shrink: 0;
    position: relative;
  }

  &__title {
    @include font-heading;

    &::before {
      content: '';
      display: block;
      width: 207px;
      height: 140px;
      background-position: center;
      background-size: contain;
      background-repeat: no-repeat;
      background-image: url('../assets/mail_mail.svg');
      position: absolute;
      bottom: calc(100% - 40px);
      right: 0;
    }
  }

  &__content {
    @include font-content;
  }

  &__form {
    display: block;
    text-align: right;
    position: relative;

    &--sending::before {
      content: '';
      display: block;
      position: absolute;
      top: 0;
      left: 0;
      right: 0;
      bottom: 0;
      background: $c_grey--light;
      z-index: 1;
      opacity: .45;
    }
  }

  &__fields-wrapper {
    display: block;
    position: relative;
    margin-bottom: 10px;
  }

  &__form--sending &__fields-wrapper::after {
    content: "";
    border: 3px solid transparent; /* Light grey */
    border-top: 3px solid $c_black; /* Blue */
    border-radius: 50%;
    width: 40px;
    height: 40px;
    animation: spin 1.3s cubic-bezier(.5,.2,.5,.8) infinite;
    display: block;
    position: absolute;
    top: calc(50% - 20px);
    left: calc(50% - 20px);
    z-index: 1;
    box-sizing: border-box;

    @keyframes spin {
      0% { transform: rotate(0deg); }
      100% { transform: rotate(360deg); }
    }
  }

  &__input {
    outline: none;
    width: 100%;
    box-sizing: border-box;
    border: 1px solid $c_grey--dark;
    height: 40px;
    font-size: 14px;
    line-height: 26px;
    padding: 6px 20px;
    background: transparent;
    margin-bottom: 10px;
    text-align: left;
    transition: border .35s;

    &:last-child {
      margin-bottom: 0;
    }

    &::placeholder {
      color: $c_grey--dark;
    }

    &.error {
      border-color: #d43;
    }
  }

  &__button {
    @include button;
    min-width: 150px;
    display: inline-block;
    outline: none;
    border: none;

    &:disabled {
      opacity: .5;
      cursor: auto;
    }
  }

  &__status {
    margin-top: 50px;

    h2 {
      margin: 0 0 10px;
      font-weight: $t_medium;
    }

    p {
      margin: 0 0 10px;
      font-weight: $t_light;
      font-size: 16px;
    }
  }

  &__gdpr {
    cursor: pointer;
    font-weight: 300;
    text-align: left;
    display: block;
    padding-left: 36px;
    position: relative;
    font-size: 14px;
    margin-bottom: 20px;

    em {
      display: block;
      position: absolute;
      top: 0;
      left: 0;
      width: 26px;
      height: 26px;
      border: 1px solid $c_grey--dark;
    }

    a {
      color: $c_purple;
    }

    input {
      visibility: hidden;
      position: absolute;
    }

    input:checked ~ em:before {
      content: '';
      display: block;
      width: 16px;
      height: 16px;
      background: $c_purple;
      position: absolute;
      top: 5px;
      left: 5px;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/views/Mail.vue